import { useState, useEffect, useRef } from "react";
import Moment from "moment";
import DatePicker from "react-multi-date-picker";

// style imports
import "./Date.css";
import "../Input/Input.css";

const DateTextField = ({ label, id, onChange, initialValue, minDate, maxDate, readOnly }) => {
  // set state for value and focus
  const [value, setValue] = useState(initialValue || null);
  const [focus, setFocus] = useState(false);
  const datePickerRef = useRef(null)

  // update the value when the initial value changes
  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
      setFocus(true);
    }
  }, [initialValue]);

  // handle onchange event
  const handleOnChange = (event) => {
    const date = Moment(new Date(event)).format("YYYY-MM-DD");
    setValue(date);
    if (onChange) {
      onChange(date);
    }
  };

  // Open calendar when label is clicked
  const handleLabelClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.openCalendar(); // Trigger the DatePicker to open
    }
    setFocus(true);
  };

  return (
    <div className="form-input" onClick={() => setFocus(true)}>
      <DatePicker
        value={initialValue ? new Date(value) : ""}
        format="DD MMM YYYY"
        onChange={handleOnChange}
        ref={datePickerRef}
        minDate={minDate} // Use dynamic minDate
        maxDate={maxDate} // Use dynamic maxDate
        readOnly={readOnly}
      />
      <label
        className={focus ? "form_focus" : ""}
        htmlFor={id}
        onClick={handleLabelClick}
      >
        {label}
      </label>
    </div>
  );
};

export default DateTextField;
